import { SurveyChipVariant } from './survey-status.types';
import styles from './survey-status.module.scss';
import Icon from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { surveyStatusIcon, surveyStatusLabelKey } from './survey-status.constants';

interface SurveyChipProps {
  variant: SurveyChipVariant;
  className?: string;
}

export const SurveyStatus = ({ variant, className }: SurveyChipProps) => {
  const { t } = useTranslation('surveys');
  const cssVariant = variant.replace(/'/g, '-').replace(/ /g, '-');

  return (
    <div className={className}>
      <div
        className={`${styles[`surveyChipIconContainer-${cssVariant}`]} ${styles.surveyChipIconContainer}`}
      >
        <Icon
          component={surveyStatusIcon[variant]}
          className={styles[`surveyChipIcon-${cssVariant}`]}
        />
      </div>
      <p className={`${styles[`surveyChip-${cssVariant}`]} ${styles.surveyStatusText}`}>
        {t(surveyStatusLabelKey[variant])}
      </p>
    </div>
  );
};
